import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { wsGetAll } from 'services/WService.js';
import { onlyInteger } from 'hooks/Pipe';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsFindBy } from 'services/WService';

export default function ModalRule(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [sellers, setSellers] = useState([]);
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);
  
  useEffect(() => {
    if (props.model?.open) {
      setDataChanging(props.model);
    }
  }, [props.model]);



  return (
    <>
      <Modal
        title={`Actualizar registro`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity='sale/grupo-incentivo'
        dataForce={{
          state: dataChanging.state,
        }}
      >
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={dataChanging.description || ''}
          required
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Estado</InputLabel>
          <Select
            required
            value={ dataChanging.state}
            inputProps={{
              name: 'state',
              onChange: (e) => handleChange('state', e.target.value),
            }}
          >
            <MenuItem value="A">Activo</MenuItem>
            <MenuItem value="I">Inactivo</MenuItem>
          </Select>
        </FormControl>
      </Modal>
    </>
  );
}
